import { Typography } from 'antd'; // Assuming you are using Ant Design

export const TruncatedModalTitle = ({ title }: { title: string }) => {
    return (
        <Typography.Paragraph className="modal-title">{title}</Typography.Paragraph>
    );
};